import React from 'react'
import ReactTable from 'react-table'
import { Pagination } from 'components'
import { getColumnArray, getColumnWidth } from './func'
import 'assets/sass/utils/table.scss'


export class Table extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { 
      sorted: [],
      tableWidth: 0,
      tableHeight: 0
    }
    this.tableRef = React.createRef();
  }

  componentDidMount() {
    const { sorted, type, model, is_mobile } = this.props;
    
    // 只在手機版進行尺寸調整
    if (is_mobile) {
      this.adjustTableSize();
    }

    if (sorted || type !== 'user') {
      let id = sorted ? sorted : null;
      let sort = 'esc';

      switch (model) {
        case 'Consensus_EPS_Estimatetable_R0001':
          id = 'date';
          sort = 'desc';

          break;

        case 'RadarSelection':
          id = 'ua120022_cp';

          break;

        case 'LatestFinancialResultRankings':
        case 'OrderVisibilitySingleRankings':
          id = 'ua60261_cp';

          break;

        case 'PublishedMonthlyRevenueSingleRankings':
        case 'RevenueMonthlyYTDExceedingAnalystExpectationsSingleRankings':
          id = 'ua70269_cp';

          break;

        default:
      }

      if (id) {
        this.setState({ sorted: [{ id: id, [sort]: true }] });
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { is_mobile, data } = this.props;
    
    // 只在手機版且數據變化時重新計算尺寸
    if (is_mobile && prevProps.data !== data) {
      this.adjustTableSize();
    }
  }

  adjustTableSize = () => {
    if (!this.tableRef.current || !this.props.is_mobile) return;

    const table = this.tableRef.current;
    const thElements = table.getElementsByClassName('rt-th');
    const tdElements = table.getElementsByClassName('rt-td');
    
    let maxWidth = 0;
    let maxHeight = 0;

    // 計算標題寬度
    Array.from(thElements).forEach(th => {
      const width = th.scrollWidth;
      const height = th.scrollHeight;
      maxWidth = Math.max(maxWidth, width);
      maxHeight = Math.max(maxHeight, height);
    });

    // 計算內容寬度
    Array.from(tdElements).forEach(td => {
      const width = td.scrollWidth;
      const height = td.scrollHeight;
      maxWidth = Math.max(maxWidth, width);
      maxHeight = Math.max(maxHeight, height);
    });

    // 設置最小寬度
    const minWidth = this.props.minWidth || 100;
    maxWidth = Math.max(maxWidth, minWidth);

    this.setState({
      tableWidth: maxWidth,
      tableHeight: maxHeight
    });
  }

  render() {
    const {
      header,
      data,
      accessor,
      type,
      cell,
      filtered,
      minWidth,
      showPagination,
      pageSize,
      sortCallback,
      singleKey,
      model,
      is_mobile,
      pager,
    } = this.props;
    const columns = getColumnArray(
      type,
      singleKey,
      data,
      model,

      header,
      accessor,
      cell,
      minWidth
    );
    const enableSorting = type !== 'user' && model !== 'ValuationSheet_Three_Haoway';

    let size = pageSize;

    if (type === 'account_single' || data.length < 10 || !showPagination) {
      size = data.length;
    }
    return (
      <div ref={this.tableRef} style={{ width: '100%', overflowX: 'auto' }}>
        <ReactTable
          className={`
            ${(type === 'user') ? 'user-table' : 'table-component ua-table'}
            ${(type === 'account_single') ? 'padding-top-15' : ''}
            notice
            ${(model === 'InvestmentsInChinaDetail') ? 'china-detail-model' : ''}
          `}
          columns={columns}
          data={data}

          initial={0}
          minRows={0}

          showPagination={!(data.length < 10 || !showPagination)}
          PaginationComponent={Pagination}
          pagerID={singleKey}
          pageSize={size}
          page={(data.length <= size) ? 0 : pager[singleKey]}

          NoDataComponent={() => null}

          enableSorting={enableSorting}
          multiSort={true}
          sorted={enableSorting ? this.state.sorted : []}

          filtered={filtered ? filtered : []}
          onFilteredChange={() => filtered ? filtered : []}

          // enableRowSelection={true}
          // enableMultiRowSelection={true}
          // onRowSelectionChange={({ row }) => ({
          //     onClick: () => {
          //       console.log('onClick: ', row);
          //     }
          // })}

          getProps={() => ({ id: singleKey ? `table_${singleKey}` : '' })}
          getTheadThProps={(props, some, column) => ({
            onClick: (e) => {
              if (!enableSorting || !column.sortable) { return; }

              const tableSort = props.sorted;

              this.setState(
                {
                  sorted: [{
                    id: column.id,
                    desc: (tableSort.length > 0 && tableSort[0].id === column.id)
                        ? !tableSort[0].desc : true
                  }],
                },
                () => { if (sortCallback) { sortCallback(); }}
              );
            },
            style: {
              minWidth: is_mobile ? (this.state.tableWidth || minWidth) : (minWidth ? minWidth : getColumnWidth(
                props.pageRows,
                column.id,
                header[accessor.indexOf(column.id)],
                is_mobile,
                model
              )),
              height: is_mobile ? (this.state.tableHeight || 'auto') : 'auto',
              transform: is_mobile ? 'translate3d(0, 0, 0)' : '',
              lineHeight: is_mobile ? 1.2 : 2.4,
            },
          })}
          getTrProps={(_, row) => ({
                    // onClick: () => {
                      // console.log('onClick: ', row);
                    // }
          })}
          getTdProps={(props, rowInfo, column) => ({
            style: {
              minWidth: is_mobile ? (this.state.tableWidth || minWidth) : (minWidth ? minWidth : getColumnWidth(
                props.pageRows,
                column.id,
                header[accessor.indexOf(column.id)],
                is_mobile,
                model
              )),
              height: is_mobile ? (this.state.tableHeight || 'auto') : 'auto',
              transform: is_mobile ? 'translate3d(0, 0, 0)' : '',
              lineHeight: is_mobile
                ? 1.2
                : (column.id === 'stock_title' || type === 'user')
                  ? ''
                  : 2.4
            },
                    // onClick: () => {
                    //     console.log('onClick: ', column);
                    // }
          })}
        />
      </div>
    );
  }
}
